import React from 'react';
import sAction from 'sAction';

export default class Custom extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            backgroundImages: sAction.param.portalLoginImages,
            actualBgImage: 'img/portal-login-background/820775768.jpeg',
            actualBgImageIndex: 0,
            prevBgImage: 'img/portal-login-background/820775768.jpeg',
            updatingBgImage: false,
        };

        if (this.state.backgroundImages && this.state.backgroundImages.length > 0) {
            setInterval(() => {
                this.changeBackgroundImage();
            }, 6000);
        }
    }


    changeBackgroundImage() {
        const {backgroundImages, actualBgImageIndex, actualBgImage} = this.state;
        let nextBgImageIndex = actualBgImageIndex + 1;
        if (nextBgImageIndex >= backgroundImages.length) {
            nextBgImageIndex = 0;
        }
        const nextBgImage = backgroundImages[nextBgImageIndex];
        if (nextBgImage) {
            this.setState({
                prevBgImage: actualBgImage,
            });
            setTimeout(() => {
                this.setState({
                    actualBgImage: nextBgImage,
                    actualBgImageIndex: nextBgImageIndex,
                    updatingBgImage: true,
                });
            }, 800);
        }
        setTimeout(() => {
            this.setState({updatingBgImage: false});
        }, 1000);
    }


    render() {
        const data = this.props.data;
        const content = data && data.get ? data.get('content') : '';

        return (

            <div>
                <div id="loginPageContainer">
                    <div id="loginContentContainer">
                        <div id="loginContainer" style={{boxShadow: 'none'}}>
                            <img className="loginContainerLogo" src={sAction.param.companyLogoDark} />

                            <div className="loginContent">
                                {content}
                            </div>
                            <a href='/' className='customBackToLogin'>{sAction.translate('LBL_BACK_TO_LOGIN')}</a>
                        </div>


                        <div className="contentContainer">
                            <div className="loginContainerGrid">
                                <div className="loginVideoContainer">
                                    {/* fade from one image to next */}
                                    <div className="loginImagesCarrousel">
                                        <img src={this.state.actualBgImage}
                                            className={'loginImg next ' + (!this.state.updatingBgImage ? ' nextFadeIn' : '')}
                                        />
                                        <img src={this.state.prevBgImage}
                                            className="loginImg prevFadeOut"
                                        />
                                    </div>
                                </div>

                                <div className="customCompanyLogo">
                                    <img src={sAction.param.companyLogo} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
